import React, {useEffect} from "react"
import { useLocation } from "react-router-dom"
import {CssBaseline, ThemeProvider} from "@mui/material"
import theme from "../theme/theme"
import SideBar from "../components/SideBar/side-bar"
import {useDocumentTitle} from "../hooks/useDocumentTitle"
import PropTypes from "prop-types"
import {Box} from "@mui/system"
import SessionTimeout from "../../utils/session-timeout"
import RefreshToken from "../../utils/refresh-token"
import Header from "../components/Header/header"
import {AlertListener} from "../components/SnackBar/snackbar-listener"
import {DuplaConfirmacaoListener} from "../components/DuplaConfirmacao/DuplaConfirmacaoListener"
import LoaderOverlay from "../components/LoaderOverlay/loader-overlay"
import Loader from "../components/Loader/loader"

const SideBarLayout = ({children, title, header, headerTitle, headerImage, loading = false, headerPosition = null, actionButton}) => {
    const location = useLocation()

    useEffect(() => {
        if (!location.pathname.includes("solicitar-acesso")) {
            localStorage.setItem("current_page", location.pathname)
        }
    }, [location.pathname])
    useDocumentTitle(title)
    const body = document.body

    body.style.width = "100dvwd"
    body.style.height = "100dvhd"
    body.style.overflowX = "auto"

    return (
        <ThemeProvider theme={theme}>
            <SessionTimeout/>

            <RefreshToken/>

            <CssBaseline/>
            <Box
                sx={{
                    display: "flex",
                    gap: 3,
                    background: theme.palette.background.primary,
                    height: "100%",
                    minHeight: "100vh",
                    width: "100%",
                    overflowX: "auto",
                }}
            >
                <SideBar/>
                <Box
                    component="main"
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        height: "100%",
                        mb: "5%",
                        width: "100%",
                        ml: {
                            lg: "233px",
                            xxxs: "0px",
                        },
                        mr: {
                            lg: "24px",
                            xxxs: "0px",
                        },
                    }}
                >
                    <AlertListener/>
                    <DuplaConfirmacaoListener/>

                    {header ?
                        <>
                            <Header
                                title={headerTitle}
                                imageBackground={headerImage || ''}
                                backgroundPosition={headerPosition}
                                actionButton={actionButton}
                            />
                            <Box sx={{
                                mt: {
                                    xxxs: "270px", // mobile
                                    lg: "210px",   // desktop
                                }, position: 'relative'
                            }}>
                                {children}
                            </Box>
                        </>
                        : children
                    }

                    {(loading) && (
                        <LoaderOverlay>
                            <Loader/>
                        </LoaderOverlay>
                    )}
                </Box>
            </Box>
        </ThemeProvider>
    )
}

SideBarLayout.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    header: PropTypes.bool,
    headerTitle: PropTypes.string,
    headerImage: PropTypes.string,
    loading: PropTypes.bool,
    headerPosition: PropTypes.string,
    actionButton: PropTypes.node
}

SideBarLayout.defaultProps = {
    title: "C2P",
}

export default SideBarLayout
